import Link from "next/link";
import Image from "next/image";
import logoWhite from "../../assets/logo podcast white.png";
import logoColor from "../../assets/logo podcast color .png";
import menuIcon from "../../assets/menu-icon.svg";
import { useRouter } from "next/router";
import ThemeToggle from "../Themes/ThemeToggle";
import { FaBars, FaSignOutAlt, FaUser, FaUserCog } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { logout, selectCurrentUser } from "@/Redux/features/auth/authSlice";
import { FaRegUserCircle } from "react-icons/fa";
import { useEffect, useState } from "react";
import { useMyInfoQuery } from "@/Redux/features/UserProfileInfo/UserProfileInfoApi";
import { useLogOutMutation } from "@/Redux/features/auth/authApi";
import { clearAudio } from "@/Redux/features/audioPlayer/audioPlayerSlice";
import { IoMdMail } from "react-icons/io";

const Header = ({ setOpen }) => {
  const router = useRouter();
  const [user, setUser] = useState({});
  const [profileDrawer, setProfileDrawer] = useState(false);

  const users = useSelector(selectCurrentUser);
  useEffect(() => {
    console.log(users, "users from header");
    setUser(users);
  }, [users]);

  const {
    data: profileInfo,
    isLoading: myInfoLoading,
    refetch: profileInfoRefetch,
  } = useMyInfoQuery();

  const picURL = profileInfo?.user?.picture?.path;

  // const [userLogout] = useLogOutMutation();
  const dispatch = useDispatch();
  const handleLogOut = async () => {
    dispatch(logout());
    dispatch(clearAudio());
    // await userLogout();
  };

  const navigation = [
    { label: "HOME", url: "/" },
    { label: "SHOWS", url: "/podcast" },
    { label: "Episode", url: "/episodes" },
    // { label: "VIDEO", url: "/videos" },
    // { label: "HOST", url: "/host" },
    // { label: "test_HOST_Detail", url: "/testHostDetail" },
    // { label: "FloatingVideo", url: "/testVideo" },
    // { label: 'BLOGS', url: '/blogs' },
    { label: "PROFILE", url: "/profile" },
  ];

  if (user?.role === "author") {
    navigation.push(
      { label: "MY PODCAST", url: "/my-podcast" },
      { label: "MY Episode", url: "/my-episode" }
    );
  }

  console.log();

  return (
    <div className=" bg-blue-100 shadow-lg dark:bg-black border-b border-blue-600  py-[1rem] sticky top-0 w-full z-40 ">
      <div className="relative max-w-screen-xl mx-auto px-5 lg:px-0 flex items-center justify-between">
        <div className="flex gap-20">
          <Link href="/">
            <Image
              className={`w-48 dark:hidden cursor-pointer`}
              src={logoColor}
              alt="Logo"
            />
            <Image
              className={`w-48 hidden dark:block cursor-pointer`}
              src={logoWhite}
              alt="Logo"
            />
          </Link>

          <nav className="hidden lg:flex items-center">
            <ul className="flex gap-[24px] text-blue-600 ">
              {user &&
                navigation?.map((item) => (
                  <li key={item.label} className="relative group">
                    <Link
                      href={item.url}
                      className={`${
                        router.pathname === item.url ? "font-bold" : ""
                      } uppercase`}
                    >
                      {item?.label}
                    </Link>

                    {item.subNav && (
                      <ul className="z-50  absolute hidden space-y-2 w-52 rounded bg-blue-700 text-white group-hover:block border border-gray-200 pl-5 py-3">
                        {item.subNav.map((subNavItem) => (
                          <li
                            className=" hover:font-semibold"
                            key={subNavItem.label}
                          >
                            <Link href={subNavItem.url}>
                              {subNavItem.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
            </ul>
          </nav>
        </div>

        {user ? (
          <>
            {picURL ? (
              <div className="hidden lg:block">
                <div className="flex gap-5 items-center">
                  <Link href="/inbox">
                    <IoMdMail className="text-blue-500 text-2xl cursor-pointer" />
                  </Link>
                  <ThemeToggle />
                  <div
                    onClick={() => setProfileDrawer(!profileDrawer)}
                    className=" cursor-pointer rounded-full w-12 h-12 md:bg-gradient-to-l  from-blue-500 to-[#3ae9da]"
                  >
                    <Image
                      className="border md:border-none border-blue-600  md:p-[2px] mx-auto w-12 h-12 rounded-full"
                      src={`${
                        profileInfo?.user?.picture?.path
                          ? profileInfo?.user?.picture?.path
                          : "/"
                      }`}
                      alt="logo"
                      priority
                      width={400}
                      height={300}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="hidden lg:block">
                <div className="flex gap-5 items-center">
                  <Link href="/inbox">
                    <IoMdMail className="text-blue-500 text-2xl cursor-pointer" />
                  </Link>
                  <ThemeToggle />
                  <FaRegUserCircle
                    onClick={() => setProfileDrawer(!profileDrawer)}
                    className=" text-4xl text-blue-600 cursor-pointer"
                  />
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="hidden lg:block ">
            <div className="flex gap-5 items-center">
              <ThemeToggle />
              <Link
                href="/login"
                className=" bg-gradient-to-r  from-blue-400 to-[#5E1CE4]  font-bold text-white py-[13px] px-[24px] rounded-full ml-[1.5rem]"
              >
                Login
              </Link>
            </div>
          </div>
        )}

        {profileDrawer && (
          <div className="w-40 absolute top-12 right-10 lg:right-0 dark:bg-gray-900 dark:text-white font-semibold bg-blue-200  py-2 rounded-md border border-blue-600">
            <p
              onClick={() => {
                setProfileDrawer(!profileDrawer);
                router.push("/profile");
              }}
              className="cursor-pointer my-auto rounded pl-4 py-2 hover:bg-gray-400 dark:hover:bg-gray-800 flex gap-2"
            >
              {" "}
              <FaUser className="my-auto" /> Profile
            </p>

            <p
              onClick={() => {
                router.push("/profile-setting");
                setProfileDrawer(!profileDrawer);
              }}
              className="cursor-pointer my-auto rounded pl-4 py-2 hover:bg-gray-400 dark:hover:bg-gray-800 flex gap-2"
            >
              {" "}
              <FaUserCog className="my-auto text-lg" /> Setting
            </p>

            <p
              onClick={() => {
                handleLogOut();
                setProfileDrawer(!profileDrawer);
              }}
              className="cursor-pointer my-auto rounded pl-4 py-2 hover:bg-gray-400 dark:hover:bg-gray-800 flex gap-2"
            >
              {" "}
              <FaSignOutAlt className="my-auto text-lg " /> LogOut
            </p>
          </div>
        )}

        {/* <ButtonPrimary text={"Login"} link='/login' /> */}

        <div className="lg:hidden flex gap-4 items-center">
          <ThemeToggle />

          <button className=" " onClick={() => setOpen(true)}>
            <FaBars className="text-xl dark:text-white" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;
